<template>
<div>
    <div class="full">
        <div class="mainheader">
            <div class="half">
                {{ $t('pages.employeeData.workTime') }}
            </div>
            <!-- <div class="half right">
                <div class="full">
                    <b-button style="display: inline;" pill variant="outline-success" @click="showModal('modal-createfile')">
                        <i class="fas fa-upload"></i>&nbsp;&nbsp;Hochladen
                    </b-button>
                </div>
            </div> -->
        </div>
    </div>
    <!-- WORK BALANCES -->
    <div class="full">
        <div class="header">
            <div v-if="useraccount" class="label">{{ $t('pages.comp.accountData') }}</div>
            <div v-else class="label">{{ $t('pages.comp.noAccountLinked') }}</div>
        </div>
        
        <div class="full" v-if="useraccount">
            <div class="half">
                <div class="full h20 split-bottom-tight">
                    <div class="third left">
                        <div class="label bold">{{ $t('pages.employeeCoreData.email') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label bold right float">{{ useraccount.email }}</div>
                    </div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('pages.employeeData.firstname') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{useraccount.firstName}}</div>
                    </div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('pages.employeeData.lastname') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{useraccount.lastName}}</div>
                    </div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('global.general.status') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ useraccount.active? $t('store.api.active') : $t('pages.comp.notActive') }}</div>
                    </div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('pages.comp.lastLogin') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ useraccount.lastLogin != null ? $helpers.getMomentFromStringTZ(useraccount.lastLogin).format("DD.MM.YYYY HH:mm") : '-' }}</div>
                    </div>
                </div>
                <div class="full h20">
                    <div class="third left">
                        <div class="label">{{ $t('pages.comp.tou') }}</div>
                    </div>
                    <div class="twothirds">
                        <div class="label right float">{{ useraccount.userAgreementDate != null ? $helpers.getMomentFromStringTZ(useraccount.userAgreementDate).format("DD.MM.YYYY HH:mm") : '-' }}</div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    components: {
    },
    name: 'employeeuseraccount',
    data() {
        return {
            useraccount: null,
            processing: false,
            dropdowns: [],
        }
    },
    watch: {
        employee: {
            deep: true,
            handler (val, oldVal){
                this.refresh();
            }
        }
    },
    props: [
        "employee",
    ],
    computed: {
        ...mapGetters([
            'userInfo',
            'storeId',
            'uiDataMap',
            'storeSettings',
        ]),
    },
    created() {
        this.refresh();
    },
    methods: {
        refresh(){
            this.processing = true;
            console.log('###### REFRESHING ######');
            var view = this;
            let url = '/api/sec/employee/account/info';
            url = this.$helpers.appendParam("id", this.employee.id, url, '/api/sec/employee/account/info');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/account/info');

            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url
            }).then((response) => {
                view.useraccount = response.data;
                view.accountInfoRefreshed();
            }).catch(function (error) {
                view.useraccount = null;
                view.accountInfoRefreshed();
                console.log(error)
            });
        },
        accountInfoRefreshed(){
            this.$emit('account-info-refreshed', this.useraccount);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/*
.content *:not(.main-settings)>.half {
    height: 105px;
}
*/
</style>
